import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isVisible: false,
  formModal: {
    status: false,
    title: "",
    type: "",
    showCloseButton: true,
    data: null,
  },
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setShowModal: (state, { payload }) => {
      state.isVisible = true;
      state.formModal = {
        status: payload.status,
        title: payload.title,
        type: payload.type,
        showCloseButton: payload?.showCloseButton ,
        data: payload.data,
      };
    },
    hideModal: (state) => {
      state.isVisible = false;
      state.data = null;
    },

  },
});

export const { setShowModal, hideModal } = modalSlice.actions;
export default modalSlice.reducer;
